import { Route } from '@angular/router';
import { CanDeactivateGuard } from '@pkp-g/core';

export const operatorRoutes: Route[] = [
  {
    path: '',
    redirectTo: 'list',
    pathMatch: 'full',
  },
  {
    path: 'list',
    loadComponent: () => import('./pages').then(p => p.OperatorListPage),
    title: 'UIMS - Operators',
  },
  {
    path: 'create',
    loadComponent: () => import('./pages').then(p => p.OperatorCreateComponent),
    title: 'UIMS - Operators',
  },
  {
    path: 'details/:id',
    loadComponent: () => import('./pages').then(p => p.OperatorDetailsComponent),
    title: 'UIMS - Operator Details',
    canDeactivate: [CanDeactivateGuard],
  },
];
